export default __webpack_public_path__ + "static/media/small_head_-6.21b594b8.webp";